// extracted by mini-css-extract-plugin
module.exports =  {"info":"xI5y8H","destinationPickerFromTax":"XFucip"};